export const TRANSLATIONS_ES = {};